<template>
  <div>
    <form method="post" @submit.prevent="submitForm">
      <div class="input-row">
        <DeployerUiFormInputText
          v-model="formValues.name"
          :placeholder="texts[0].label"
        />
        <DeployerUiFormInputText
          v-model="formValues.email"
          :placeholder="texts[1].label"
        />
      </div>
      <DeployerUiFormInputTextarea
        v-model="formValues.message"
        :placeholder="texts[2].label"
      />
      <button
        type="submit"
        class="btn grey-border mt20"
        v-html="texts[3].label"
      ></button>
    </form>
  </div>
</template>

<script setup>
const formValues = ref({
  name: '',
  email: '',
  message: ''
})

const textsStore = useTextsStore()
const texts = computed(
  () => textsStore.account.support.box_feedback.form_labels
)

//TODO: Kamil - implement submitForm
const submitForm = () => {
  console.log(formValues.value)
}
</script>

<style lang="scss" scoped>
.input-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 5px;
  margin-block: 15px;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}
</style>
